<template>
  <section
    data-cy="message-detail-content"
    :data-view-ready="!loading">
    <div
      v-if="source !== 'modal'"
      class="d-flex"
      style="justify-content: space-between; align-items: center;">
      <h5 class="modal-title mb-3">
        {{ $t('message.marketingMessages.detailEmail') }}
      </h5>
      <div>
        <a
          v-if="ticket"
          class="d-inline-block linkTicket mr-3"
          @click="routeToDetail(ticket)"
          @click.middle="openMiddleDetail(ticket)">
          <span
            :id="'tooltip-title-' + source + ticket.key">
            <img
              height="20px"
              class="mr-1 mb-1"
              :src="`/img/ticket/${ticket.type.split('TICKET_TYPE_')[1].toLowerCase()}.svg`"
              alt="type">{{ $t('message.ticketOverview.ticket.type.' + ticket.type) }} {{ ticket.key }}
          </span>
          <b-tooltip
            :target="'tooltip-title-' + source + ticket.key"
            triggers="hover">
            {{ ticket.title }}
          </b-tooltip>
        </a>
        <coozzy-form-checkbox
          v-model="confidentialEmail"
          :initial="confidentialEmail"
          class="d-inline-block mr-4 pr-0 align-self-center"
          name="confidentialEmail"
          @change="(value) => { markAsConfidential(value) }">
          {{ $t('message.settings.confidentialEmails.confidential') }}
        </coozzy-form-checkbox>
      </div>
    </div>
    <div
      v-if="loading"
      class="text-center">
      <coozzy-spinner />
    </div>
    <template v-else>
      <div class="row">
        <!-- Action buttons -->
        <div class="col clearfix">
          <coozzy-dropdown
            v-if="mobileView"
            class="col-auto mr-md-3 mr-1 mb-2 pl-0 pr-1 pr-md-2 more-btn"
            design="light"
            :icon="'reply'"
            size="sm">
            <coozzy-dropdown-item
              v-if="email.spam === false || (email.spam === true && email.inTrash === true)"
              class="col-auto mr-3 mb-2"
              @click="reply">
              <coozzy-reply-icon class="mb-1" />
              <span
                v-if="!minimized"
                class="ml-1">{{ $t('message.marketingMessages.reply') }} </span>
            </coozzy-dropdown-item>
            <coozzy-dropdown-item
              v-if="email.spam === false || (email.spam === true && email.inTrash === true)"
              class="col-auto mr-3 mb-2"
              @click="replyAll">
              <coozzy-reply-all-icon class="mb-1" />
              <span
                v-if="!minimized"
                class="ml-1">{{ $t('message.marketingMessages.replyAll') }} </span>
            </coozzy-dropdown-item>
            <coozzy-dropdown-item
              v-if="email.spam === false || (email.spam === true && email.inTrash === true)"
              class="col-auto mr-3 mb-2"
              @click="forwardMail">
              <coozzy-forward-icon class="mb-1" />
              <span
                v-if="!minimized"
                class="ml-1">{{ $t('message.marketingMessages.forward') }} </span>
            </coozzy-dropdown-item>
          </coozzy-dropdown>
          <template v-else>
            <coozzy-button
              v-if="email.spam === false || (email.spam === true && email.inTrash === true)"
              class="col-auto mr-3 mb-2"
              @click="reply">
              <coozzy-reply-icon class="mb-1" />
              <span
                v-if="!minimized"
                class="ml-1">{{ $t('message.marketingMessages.reply') }} </span>
            </coozzy-button>
            <coozzy-button
              v-if="email.spam === false || (email.spam === true && email.inTrash === true)"
              class="col-auto mr-3 mb-2"
              @click="replyAll">
              <coozzy-reply-all-icon class="mb-1" />
              <span
                v-if="!minimized"
                class="ml-1">{{ $t('message.marketingMessages.replyAll') }} </span>
            </coozzy-button>
            <coozzy-button
              v-if="email.spam === false || (email.spam === true && email.inTrash === true)"
              class="col-auto mr-3 mb-2"
              @click="forwardMail">
              <coozzy-forward-icon class="mb-1" />
              <span
                v-if="!minimized"
                class="ml-1">{{ $t('message.marketingMessages.forward') }} </span>
            </coozzy-button>
          </template>
          <template
            v-if="email.spam === false || (email.spam === true && email.inTrash === true)">
            <coozzy-button
              v-if="email.archived"
              class="col-auto mr-md-3 mr-1 mb-2"
              @click="restoreMailClick()">
              <coozzy-file-icon class="mb-1" />
              <span
                v-if="!minimized"
                class="ml-1">{{ $t('message.generic.restore') }} </span>
            </coozzy-button>
            <coozzy-button
              v-else
              class="col-auto mr-md-3 mr-1 mb-2"
              @click="archiveMailClick()">
              <coozzy-file-icon class="mb-1" />
              <span
                v-if="!minimized"
                class="ml-1">{{ $t('message.generic.archive') }} </span>
            </coozzy-button>
          </template>
          <coozzy-button
            v-if="email.spam === true && !email.inTrash"
            class="col-auto mr-md-3 mr-1 mb-2"
            @click="markAsNoSpam()">
            <coozzy-spam-icon />
            <span
              v-if="!minimized"
              class="ml-1">{{ $t('message.marketingMessages.markAsNoSpam') }} </span>
          </coozzy-button>
          <coozzy-button
            v-if="!email.inTrash"
            class="col-auto mr-md-3 mr-1 mb-2"
            @click="deleteMailClick()">
            <coozzy-delete-icon />
            <span
              v-if="!minimized"
              class="ml-1">{{ $t('message.generic.delete') }} </span>
          </coozzy-button>
          <coozzy-dropdown
            v-if="email.spam === false || (email.spam === true && email.inTrash === true)"
            data-cy="message-more-dropdown"
            :text="$t('message.generic.more')"
            class="col-auto mr-md-3 mr-1 mb-2 pl-0 pr-0 pr-md-2 more-btn"
            design="light"
            size="sm">
            <!--       SubMenu Create       -->
            <coozzy-dropdown
              data-cy="message-create-dropdown"
              :text="$t('message.generic.create')"
              class="w-100 ticket-dropdown-bulk-action enabled"
              design="transparent"
              dropright
              size="sm">
              <coozzy-dropdown-item
                v-if="isTicketingEnabled && (isEditor || isTicketEditor || isTicketCreator || isCompanyAdmin) && !isOwnerModule && !isAssetModule"
                @click="redirectToCreateOrder">
                {{ $t('message.ticketOverview.createOrder') }}
              </coozzy-dropdown-item>
              <coozzy-dropdown-item
                v-if="isTicketingEnabled && (isEditor || isTicketEditor || isTicketCreator || isCompanyAdmin) && !isOwnerModule && !isAssetModule"
                @click="showAddTicketConnectionsModal('TICKET_TYPE_TASK')">
                {{ $t('message.marketingMessages.createTask') }}
              </coozzy-dropdown-item>
              <coozzy-dropdown-item
                v-if="isTicketingEnabled && (isEditor || isTicketEditor || isTicketCreator || isCompanyAdmin) && !isOwnerModule && !isAssetModule"
                @click="showAddTicketConnectionsModal('TICKET_TYPE_CHECKLIST')">
                {{ $t('message.ticketOverview.createChecklist') }}
              </coozzy-dropdown-item>
              <coozzy-dropdown-item
                data-cy="message-create-reminder-item"
                @click="showCreateReminderModal">
                {{ $t('message.calendar.reminder.create') }}
              </coozzy-dropdown-item>
            </coozzy-dropdown>
            <!--       SubMenu Link       -->
            <coozzy-dropdown
              :text="$t('message.generic.link')"
              class="w-100 ticket-dropdown-bulk-action enabled"
              design="transparent"
              dropright
              size="sm">
              <coozzy-dropdown-item
                v-if="!hasAccessUserBase"
                @click="linkToContact">
                {{ $t('message.marketingMessages.linkToContact') }}
              </coozzy-dropdown-item>
              <coozzy-dropdown-item
                v-if="!hasAccessUserBase && hasAccessMarketBase"
                @click="linkToRequest">
                {{ $t('message.marketingMessages.linkToRequest') }}
              </coozzy-dropdown-item>
              <coozzy-dropdown-item
                @click="linkToTicket">
                {{ $t('message.marketingMessages.linkToTicket') }}
              </coozzy-dropdown-item>
            </coozzy-dropdown>
            <coozzy-dropdown-item
              v-if="!hasAccessUserBase && (getManuallyAssignedContactId(email, email.referenceIds) || (firstContactReferenceId && firstContactReferenceId.length)) && !($route.name && $route.name.endsWith('ContactDetailsView'))"
              @click="showContactDetail(firstContactReferenceId)">
              {{ $t('message.marketingMessages.toContact') }}
            </coozzy-dropdown-item>
            <coozzy-dropdown-item
              @click="generatePDFBodyEmail(true)">
              {{ $t('message.marketingMessages.forwardAsAttachment') }}
            </coozzy-dropdown-item>
            <coozzy-dropdown-item
              v-if="email.spam === false"
              @click="markAsSpam">
              {{ $t('message.marketingMessages.markAsSpam') }}
            </coozzy-dropdown-item>
            <coozzy-dropdown-item
              @click="generatePDFBodyEmail(false)">
              {{ $t('message.marketingMessages.print') }}
            </coozzy-dropdown-item>
          </coozzy-dropdown>
          <div
            v-if="!email.inbound"
            class="col-auto mr-3 mb-2 mt-2 deliver-status">
            <label> {{ $t('message.tableColumnHeadings.receivedOpened') }}: &nbsp;</label>
            <template v-if="email.mailType === 'MAIL_TYPE_IMIP'">
              -
            </template>
            <template v-else>
              <template v-if="email.deliverData.status === 'DELIVER_STATUS_DELIVERED'">
                <coozzy-success-icon />
              </template>
              <template v-else-if="email.deliverData.status === 'DELIVER_STATUS_PENDING'">
                <coozzy-pending-icon />
              </template>
              <template v-else>
                <coozzy-fail-icon
                  v-b-tooltip.hover.left
                  :title="email.deliverData.errorMessage" />
              </template>
              /
              <template v-if="email.engagementData.status === 'ENGAGEMENT_STATUS_OPENED'">
                <coozzy-success-icon />
              </template>
              <template v-else>
                <coozzy-fail-icon />
              </template>
            </template>
          </div>
        </div>
      </div>
      <print-message
        v-if="emailUpdated"
        ref="printMessage"
        :key="dynamicId"
        :email="emailUpdated"
        :medias-list="mediasList"
        :print-allow="printAllow"
        :ticket="ticket" />
    </template>
    <b-modal
      :id="'confirmationModal'"
      ref="confirmationModal"
      :title="$t('message.marketingMessages.confirmModal.confirmationTitle')"
      hide-footer
      no-close-on-backdrop>
      <div
        v-if="loadDeleting"
        class="text-center">
        <coozzy-spinner />
      </div>
      <template v-else>
        <div
          class="col p-0">
          <p>{{ $t('message.marketingMessages.confirmModal.confirmationTextDeleteOneMail') }}</p>
        </div>
        <div class="col p-0">
          <coozzy-button
            class="mb-0 border"
            design="default"
            size="small"
            :disabled="loadDeleting"
            @click="$bvModal.hide('confirmationModal')">
            {{ $t('message.generic.cancel') }}
          </coozzy-button>
          <coozzy-button
            class="float-right mb-0"
            design="green"
            size="small"
            :disabled="loadDeleting"
            @click="deleteMail()">
            {{ $t('message.generic.delete') }}
          </coozzy-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      :id="'archiveConfirmationModal'"
      ref="archiveConfirmationModal"
      :title="$t('message.marketingMessages.confirmModal.confirmationTitle')"
      hide-footer
      no-close-on-backdrop>
      <div
        v-if="loading"
        class="text-center">
        <coozzy-spinner />
      </div>
      <template v-else>
        <div
          class="col p-0">
          <p>{{ $t('message.marketingMessages.confirmModal.confirmationTextArchive') }}</p>
        </div>
        <div class="col p-0">
          <coozzy-button
            class="mb-0 border"
            design="default"
            size="small"
            :disabled="loadArchiving"
            @click="$bvModal.hide('archiveConfirmationModal')">
            {{ $t('message.generic.cancel') }}
          </coozzy-button>
          <coozzy-button
            class="float-right mb-0"
            design="green"
            size="small"
            :disabled="loadArchiving"
            @click="archiveMail()">
            {{ $t('message.generic.archive') }}
          </coozzy-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      :id="'restoreConfirmationModal'"
      ref="restoreConfirmationModal"
      :title="$t('message.marketingMessages.confirmModal.confirmationTitle')"
      hide-footer
      no-close-on-backdrop>
      <div
        v-if="loading"
        class="text-center">
        <coozzy-spinner />
      </div>
      <template v-else>
        <div
          class="col p-0">
          <p>{{ $t('message.marketingMessages.confirmModal.confirmationTextRestoreFromArchive') }}</p>
        </div>
        <div class="col p-0">
          <coozzy-button
            class="mb-0 border"
            design="transparent"
            size="small"
            :disabled="loadRestoring"
            @click="$bvModal.hide('restoreConfirmationModal')">
            {{ $t('message.generic.cancel') }}
          </coozzy-button>
          <coozzy-button
            class="float-right mb-0"
            design="green"
            size="small"
            :disabled="loadRestoring"
            @click="restoreMail()">
            {{ $t('message.generic.restore') }}
          </coozzy-button>
        </div>
      </template>
    </b-modal>
    <reminder-creation-modal
      ref="reminder-creation"
      :references-ids="[email.id || email.objectID]"
      :source="'message'"
      :contact-id="contactIdReminder"
      :available-contacts="contacts"
      :contacts-references="referenceIdsReminder"
      @refresh-list="refreshEmailList" />
    <add-ticket-connections-modal
      v-if="addTicketConnectionsModal"
      ref="addTicketConnectionsModal"
      :ticket-type="ticketType"
      :email="email"
      @close-modal="closeAddTicketConnectionsModal" />
  </section>
</template>

<script>

import { responsivity } from '@/mixins/responsivity'
import ReminderCreationModal from '@/calendar/components/ReminderCreationModal'
import CoozzyButton from '@/framework/components/button/CoozzyButton'
import { user } from '@/mixins/user'
import { media } from '@/mixins/media'
import { contact } from '@/mixins/contact'
import PrintMessage from '@/contact/components/PrintMessage'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import MediaApi from '../../misc/apis/MediaApi'
import CoozzyFileIcon from '../../framework/components/icons/CoozzyFileIcon'
import CoozzyReplyIcon from '@/framework/components/icons/CoozzyReplyIcon'
import CoozzyReplyAllIcon from '@/framework/components/icons/CoozzyReplyAllIcon'
import CoozzyForwardIcon from '@/framework/components/icons/CoozzyForwardIcon'
import Vue from 'vue'
import MessageApi from '@/misc/apis/MessageApi'
import { routeChecks } from '@/mixins/routeChecks'
import { request } from '@/mixins/request'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner'
import CoozzyDeleteIcon from '@/framework/components/icons/CoozzyDeleteIcon'
import CoozzySpamIcon from '@/framework/components/icons/CoozzySpamIcon'
import { mail } from '@/mixins/mail'
import { algolia } from '@/mixins/algolia'
import CoozzyDropdownItem from '@/framework/components/dropdown/CoozzyDropdownItem.vue'
import CoozzyDropdown from '@/framework/components/dropdown/CoozzyDropdown.vue'
import CoozzyFormCheckbox from '@/framework/components/form/checkbox/CoozzyFormCheckbox.vue'
import AddTicketConnectionsModal from '@/management/components/ticket/addTicketConnectionsModal.vue'
import PDFMerger from 'pdf-merger-js'
import CoozzyFailIcon from '@/framework/components/icons/CoozzyFailIcon.vue'
import CoozzyPendingIcon from '@/framework/components/icons/CoozzyPendingIcon.vue'
import CoozzySuccessIcon from '@/framework/components/icons/CoozzySuccessIcon.vue'

export default {
  name: 'MessageDetailContent',
  components: {
    CoozzySuccessIcon,
    CoozzyPendingIcon,
    CoozzyFailIcon,
    AddTicketConnectionsModal,
    CoozzyFormCheckbox,
    CoozzyDropdown,
    CoozzyDropdownItem,
    ReminderCreationModal,
    CoozzyDeleteIcon,
    CoozzySpinner,
    CoozzyReplyIcon,
    CoozzyButton,
    CoozzyFileIcon,
    CoozzyReplyAllIcon,
    CoozzyForwardIcon,
    CoozzySpamIcon,
    PrintMessage
  },
  mixins: [algolia, routeChecks, user, mail, media, contact, request, responsivity],
  props: {
    minimized: {
      type: Boolean,
      default: false
    },
    contact: {
      type: Object,
      default() {
        return null
      }
    },
    email: {
      type: Object,
      default() {
        return null
      }
    },
    ticket: {
      type: Object,
      default() {
        return null
      }
    },
    source: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      mediasList: [],
      printAllow: false,
      loading: true,
      loadArchiving: false,
      loadRestoring: false,
      loadDeleting: false,
      confidentialEmail: false,
      documentDirection: '',
      ticketType: '',
      dynamicId: '',
      emailUpdated: null,
      addTicketConnectionsModal: false,
      contactIdReminder: '',
      referenceIdsReminder: []
    }
  },
  computed: {
    ...mapState('request', ['marketplace']),
    ...mapGetters('message', ['getMailboxesForUserId']),
    firstContactReferenceId() {
      return this.email.referenceIds.find(referenceId => referenceId.startsWith('contact_')) || []
    },
    mailboxesForCurrentUser() {
      return this.getMailboxesForUserId(this.userId)
    },
    selectedEntriesText() {
      return this.$t('message.generic.selectedEntries') + ':  ' + this.selectedEntries.length
    },
    mailId() {
      return this.email.id || this.email.objectID
    }
  },
  watch: {
    printAllow: function (newVal) {
      this.$emit('print-message', newVal)
    },
    loading: function (newVal) {
      this.$emit('loading-message', newVal)
    },
    mailId: {
      immediate: true,
      handler() {
        this.tryAutoMarkMailAsRead(this.email)
      }
    }
  },
  mounted() {
    this.checkConfidentialMail()
    if (this.email.missingHtml) {
      MessageApi.listMailsByIds([this.email.id])
        .then(response => {
          if (response.mails?.length === 1) {
            this.dynamicId = Math.random().toString(36).substr(2, 9)
            this.emailUpdated = response.mails[0]
          }
        })
        .catch(e => {
          console.log(e)
          Vue.toasted.show(this.$t('message.generic.error'), { type: 'error' })
        })
        .finally(() => {
          this.loading = false
        })
    } else {
      this.loading = false
      this.emailUpdated = this.email
    }
    this.mediasList = []
    const cidMappedMediaIds = this.getCidMappedMediaIds()
    const attachmentIdsFromAttachmentObjects = (this.email.attachments || [])
      .map(attachment => attachment.mediaId)
      .filter(Boolean)
    const attachmentIds = attachmentIdsFromAttachmentObjects.length > 0
      ? attachmentIdsFromAttachmentObjects
      : (this.email.attachmentMediaIds || [])
    const filteredAttachmentIds = attachmentIds.filter(mediaId => !cidMappedMediaIds.has(mediaId))

    if (filteredAttachmentIds.length > 0) {
      MediaApi.getListMedia(filteredAttachmentIds)
        .then(response => {
          for (const media of response.media) {
            this.addMediaUnique(media)
          }
        })
        .catch(() => {
          Vue.toasted.show(this.$t('message.loadingErrors.media'), { type: 'error' })
        })
    }

    // Load CID-mapped media separately for inline image rendering in body HTML.
    if (cidMappedMediaIds.size > 0) {
      const cidMediaIds = [...cidMappedMediaIds].filter(mediaId => !filteredAttachmentIds.includes(mediaId))

      if (cidMediaIds.length > 0) {
        MediaApi.getListMedia(cidMediaIds)
          .then(response => {
            for (const media of response.media) {
              this.addMediaUnique(media)
            }
          })
          .catch(() => {
            // Silent fail for CID images - they will be removed from display
            console.log('Error loading CID-mapped images')
          })
      }
    }
  },
  methods: {
    ...mapMutations('message', ['setChangingStatusMails']),
    ...mapActions('message', ['loadMailboxesForUserId']),
    getCidMappedMediaIds() {
      return new Set((this.email.cidMappings || []).map(mapping => mapping.mediaId).filter(Boolean))
    },
    addMediaUnique(media) {
      if (!this.mediasList.find(existingMedia => existingMedia.id === media.id)) {
        this.mediasList.push(media)
      }
    },
    showCreateReminderModal() {
      this.referenceIdsReminder = []
      const refs = this.email.referenceIds ? this.email.referenceIds.filter(ref => ref.startsWith('contact_')) : []
      refs.forEach(ref => {
        const contact = this.contacts.find(contact => contact.id === ref)
        if (contact && contact.email && contact.email.toLowerCase() !== this.userEmail?.toLowerCase()) {
          this.referenceIdsReminder.push(contact.id)
        }
      })
      if (this.referenceIdsReminder.length > 0) {
        this.contactIdReminder = this.referenceIdsReminder[0]
      } else {
        this.contactIdReminder = ''
      }
      this.$nextTick(function () {
        this.$refs['reminder-creation'].show()
      })
    },
    showAddTicketConnectionsModal(type) {
      this.ticketType = type
      this.addTicketConnectionsModal = true
      this.$nextTick(function () {
        this.$refs.addTicketConnectionsModal?.show()
      })
    },
    closeAddTicketConnectionsModal() {
      this.addTicketConnectionsModal = false
    },
    checkConfidentialMail() {
      // Persisted flag is authoritative for existing emails; mailbox/domain
      // defaults belong in SendMailModal compose only (COOZ-15727).
      this.confidentialEmail = !!this.email.confidential
      this.$emit('confidential-updated', this.confidentialEmail)
    },
    markAsConfidential(bool) {
      MessageApi.setConfidential([this.email.id], bool)
        .then(() => {
          this.email.confidential = bool
          this.$emit('refresh-list-after-close', this.email.id || this.email.objectID)
        })
        .catch(() => {
          Vue.toasted.show(this.$t('message.generic.error'), { type: 'error' })
        })
    },
    refreshEmailList() {
      this.$emit('refresh-reminders')
    },
    hide() {
      this.$emit('hide')
    },
    async markAsSpam() {
      this.loading = true
      this.setChangingStatusMails([this.email.id || this.email.objectID])
      MessageApi.markAsSpam([this.email.id || this.email.objectID])
        .then(async () => {
          this.hide()
          this.$emit('refresh-list', this.email.id || this.email.objectID)
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async markAsNoSpam() {
      this.loading = true
      this.setChangingStatusMails([this.email.id || this.email.objectID])
      MessageApi.markAsNoSpam([this.email.id || this.email.objectID])
        .then(async () => {
          this.hide()
          this.$emit('refresh-list', this.email.id || this.email.objectID)
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteMailClick() {
      this.$refs.confirmationModal.show()
    },
    archiveMailClick() {
      this.$refs.archiveConfirmationModal.show()
    },
    restoreMailClick() {
      this.$refs.restoreConfirmationModal.show()
    },
    buildPrintableMessageHtml() {
      const printMessageComponent = this.$refs.printMessage
      if (!printMessageComponent || !printMessageComponent.$el) {
        return ''
      }

      const clonedRoot = printMessageComponent.$el.cloneNode(true)
      const bodyShadowComponent = printMessageComponent.$refs?.bodyHtmlShadow
      const bodyShadowHtml = bodyShadowComponent?._shadowRoot?.innerHTML || ''
      const resolvedBodyHtml = printMessageComponent.bodyHtml || ''

      const bodyContainers = clonedRoot.querySelectorAll('.printMessageBodyEmailContent')
      bodyContainers.forEach((container) => {
        // Preserve rendered Shadow DOM for print/PDF serialization.
        if (bodyShadowHtml) {
          container.innerHTML = bodyShadowHtml
          return
        }

        if (resolvedBodyHtml) {
          container.innerHTML = resolvedBodyHtml
        }
      })

      return clonedRoot.outerHTML
    },
    async generatePDFBodyEmail(forward = false) {
      const merger = new PDFMerger()
      // Fetch the CSS file dynamically (from /assets or /public directory)
      const cssResponse = await fetch('/printEmailScss.css') // Adjust the path
      const cssText = await cssResponse.text() // Convert CSS file to text
      const printableContentHtml = this.buildPrintableMessageHtml()
      const contentHTML = `
          <html>
            <head>
                <style>${cssText}</style>
            </head>
            <body>
              ${printableContentHtml}
            </body>
          </html>
        `

      // Create FormData to send HTML and CSS
      const formData = new FormData()
      const htmlBlob = new Blob([contentHTML], { type: 'text/html' })
      formData.append('files', htmlBlob, 'index.html')

      MessageApi.renderPDF(formData).then(async (response) => {
        // Create a Blob from the response
        const file = new Blob([response], { type: 'application/pdf' })
        // const blobUrl = URL.createObjectURL(blob)
        if (forward === false) {
          await merger.add(file)
          if (this.mediasList.length > 0) {
            for (let i = 0; i < this.mediasList.length; i++) {
              if (this.mediasList[i].url && this.mediasList[i].url.endsWith('.pdf')) {
                await merger.add(this.mediasList[i].url)
              }
            }
          }

          const mergedPdf = await merger.saveAsBlob()
          const url = URL.createObjectURL(mergedPdf)

          const iframeId = 'pdfPrintFrame'
          let iframe = document.getElementById(iframeId)

          // Create iframe only once
          if (!iframe) {
            iframe = document.createElement('iframe')
            iframe.id = iframeId
            iframe.style.display = 'none'
            document.body.appendChild(iframe)
          }
          iframe.src = url

          iframe.onload = function () {
            iframe.contentWindow.focus()
            iframe.contentWindow.print()
          }
        } else {
          this.documentDirection = 'email'
          this.sendFile(file)
        }
      }).catch(e => {
        console.log(e)
        Vue.toasted.show(this.$t('message.savingErrors.file'), { type: 'error' })
      })
    },
    forwardAsAttachment() {
      this.hide()
      this.$emit('forward-as-attachment', this.mediasList, this.email)
      this.documentDirection = ''
    },
    sendFile(file) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('filename', 'Email.pdf')
      formData.append('public', 'false')
      MediaApi.uploadMedia(formData).then(response => {
        this.mediasList.push(response)
        if (this.documentDirection === 'email') {
          this.forwardAsAttachment()
        }
      })
        .catch(e => {
          console.log(e)
          Vue.toasted.show(this.$t('message.savingErrors.file'), { type: 'error' })
        })
    },
    async deleteMail() {
      this.loadDeleting = true
      this.setChangingStatusMails([this.email.id || this.email.objectID])
      try {
        await MessageApi.deleteMails([this.email.id || this.email.objectID])
        this.hide()
        this.$emit('delete-mail', this.email.id || this.email.objectID)
      } catch (e) {
        console.log(e)
        Vue.toasted.show(this.$t('message.deleteErrors.mail'), { type: 'error' })
      } finally {
        this.loadDeleting = false
        if (this.$refs.confirmationModal) {
          this.$refs.confirmationModal.hide()
        }
      }
    },
    async archiveMail() {
      this.loadArchiving = true
      this.setChangingStatusMails([this.email.id || this.email.objectID])
      try {
        await MessageApi.archiveMails([this.email.id || this.email.objectID])
        this.$emit('archive-mail', this.email.id || this.email.objectID)
        this.hide()
      } catch (e) {
        console.log(e)
        Vue.toasted.show(this.$t('message.deleteErrors.archive'), { type: 'error' })
      } finally {
        this.loadArchiving = false
        if (this.$refs.archiveConfirmationModal) {
          this.$refs.archiveConfirmationModal.hide()
        }
      }
    },
    async restoreMail() {
      this.loadRestoring = true
      this.setChangingStatusMails([this.email.id || this.email.objectID])
      try {
        await MessageApi.unarchiveMails([this.email.id || this.email.objectID])
        this.hide()
        this.$emit('restore-mail', this.email.id || this.email.objectID)
      } catch (e) {
        console.log(e)
        Vue.toasted.show(this.$t('message.deleteErrors.archive'), { type: 'error' })
      } finally {
        this.loadRestoring = false
        if (this.$refs.restoreConfirmationModal) {
          this.$refs.restoreConfirmationModal.hide()
        }
      }
    },
    reply() {
      this.hide()
      this.$emit('reply-mail', this.emailUpdated || this.email)
    },
    replyAll() {
      this.hide()
      this.$emit('reply-all-mail', this.emailUpdated || this.email)
    },
    forwardMail() {
      this.hide()
      this.$emit('forward-mail', this.emailUpdated || this.email)
    },
    linkToContact() {
      const mailboxesForCurrentUser = this.mailboxesForCurrentUser.map(x => x.outboundEmail)
      let emailToLink = ''
      if (mailboxesForCurrentUser.includes(this.email.from.email)) {
        emailToLink = this.email.to[0].email
      } else {
        emailToLink = this.email.from.email
      }
      if (this.isOwnerModule) {
        this.$router.push({
          name: 'OwnerContactOverview',
          query: {
            linkMail: this.email.objectID || this.email.id,
            email: emailToLink
          }
        })
      } else if (this.isMarketingModule) {
        this.$router.push({
          name: 'MarketingContactOverview',
          query: {
            linkMail: this.email.objectID || this.email.id,
            email: emailToLink
          }
        })
      } else if (this.isAccountingModule) {
        this.$router.push({
          name: 'AccountingContactOverview',
          query: {
            linkMail: this.email.objectID || this.email.id,
            email: emailToLink
          }
        })
      } else if (this.isAdminModule) {
        this.$router.push({
          name: 'AdminContactOverview',
          query: {
            linkMail: this.email.objectID || this.email.id,
            email: emailToLink
          }
        })
      } else if (this.isAssetModule) {
        this.$router.push({
          name: 'AssetContactOverview',
          query: {
            linkMail: this.email.objectID || this.email.id,
            email: emailToLink
          }
        })
      }
      this.$nextTick(() => {
        this.hide()
      })
    },
    linkToTicket() {
      const query = {
        nameLinked: this.getMailConnectedWithContacts(this.email) ? this.getMailConnectedWithContacts(this.email).from.name === '' && this.getMailConnectedWithContacts(this.email).from.contactId === null ? this.getMailConnectedWithContacts(this.email).from.email : this.getMailConnectedWithContacts(this.email).from.name : this.email.from.name ? this.email.from.name : this.email.from.email,
        linkEmail: this.email.objectID || this.email.id
      }
      if (this.isOwnerModule) {
        this.$router.push({
          name: 'OwnerTicketOverview',
          query: query
        })
      } else if (this.isMarketingModule) {
        this.$router.push({
          name: 'MarketingTicketOverview',
          query: query
        })
      } else if (this.isAdminModule) {
        this.$router.push({
          name: 'AdminTicketOverview',
          query: query
        })
      } else if (this.isAccountingModule) {
        this.$router.push({
          name: 'AccountingTicketOverview',
          query: query
        })
      } else if (this.isAssetModule) {
        this.$router.push({
          name: 'AssetTicketOverview',
          query: query
        })
      }
      this.$nextTick(() => {
        this.hide()
      })
    },
    linkToRequest() {
      const mailboxesForCurrentUser = this.mailboxesForCurrentUser.map(x => x.outboundEmail)
      let email = ''
      if (mailboxesForCurrentUser.includes(this.email.from.email)) {
        email = this.email.to[0].email
      } else {
        email = this.email.from.email
      }
      this.$router.push({
        name: 'MarketingObjectsView',
        query: {
          linkMail: this.email.objectID || this.email.id,
          linkEmail: email,
          linkContactId: this.email.referenceIds.find(id => id.startsWith('contact_'))
        }
      })
      this.$nextTick(() => {
        this.hide()
      })
    },
    showContactDetail(contactId) {
      if (contactId !== null) {
        if (this.isOwnerModule) {
          this.$router.push({
            name: 'OwnerContactDetailsView',
            params: { id: contactId }
          })
        } else if (this.isMarketingModule) {
          this.$router.push({
            name: 'MarketingContactDetailsView',
            params: { id: contactId }
          })
        } else if (this.isAdminModule) {
          this.$router.push({
            name: 'AdminContactDetailsView',
            params: { id: contactId }
          })
        } else if (this.isAccountingModule) {
          this.$router.push({
            name: 'AccountingContactDetailsView',
            params: { id: contactId }
          })
        }
      }
      this.$nextTick(() => {
        this.hide()
      })
    },
    redirectToCreateOrder() {
      const query = {
        source: this.email ? 'email' : 'ticket'
      }
      if (this.email) {
        query.emailsData = JSON.stringify({ id: this.email.id || this.email.objectID, referenceIds: this.email.referenceIds })
        query.contactIds = this.email.referenceIds.join(',')
      }
      const currentRoute = { name: this.$router.currentRoute.name, params: this.$router.currentRoute.params, query: this.$router.currentRoute.query }
      localStorage.setItem('LS_ROUTE_KEY', JSON.stringify(currentRoute))
      if (this.isOwnerModule) {
        this.$router.push({
          name: 'OwnerCreateOrderView',
          query: query
        }, () => {
        })
      } else if (this.isAdminModule) {
        this.$router.push({
          name: 'AdminCreateOrderView',
          query: query
        }, () => {
        })
      } else if (this.isAssetModule) {
        this.$router.push({
          name: 'AssetCreateOrderView',
          query: query
        }, () => {
        })
      } else if (this.isAccountingModule) {
        this.$router.push({
          name: 'AccountingCreateOrderView',
          query: query
        }, () => {
        })
      }
      this.$nextTick(() => {
        this.hide()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.more-btn button) {
  border-radius: 0.2rem;
  color: #515151;
  font-size: .875rem;
  line-height: 1.5;
  background-color: #fff;
  border: 1px solid #ced4da;
}

p {
  white-space: pre-wrap;
}

.media-block {
  max-width: 33%;
  margin-right: 0.5%;
}

.close-img {
  width: 15px;
}
.deliver-status {
  position: absolute;
  right: 0;
  top: 0;
}

.section-to-print {
  opacity: 1;
  background-color: #FFF;
  position: fixed;
  overflow: auto;
  width: 100%;
  height: 100%;
  min-height: 200px;
  top: 0;
  left: 0;
  padding: 15px;
  margin: 0;
  z-index: 1000;
}

.section-to-print-bg {
  background-color: transparent !important;
}

:deep(.ticket-dropdown-bulk-action button) {
  border: 0;
}

.linkTicket {
  cursor: pointer;
  color: #007bff !important;
}
#archiveConfirmationModal___BV_modal_outer_, #confirmationModal___BV_modal_outer_, #restoreConfirmationModal___BV_modal_outer_ {
  z-index: 8001 !important;
}
</style>
